import * as gfunctions from '../../../js/generalFunctions';

CCL.giftLinkModal = {
  autoload: [
    ['modalEvents', $('#giftLinkModal').length > 0]
  ],

  modalEvents() {
    const modalEl = $('#giftLinkModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-gift-link-modal/gift-link-modal.js